import React, { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { useParentAuthSync } from './hooks/useParentAuthSync';

const App: React.FC = () => {
  useParentAuthSync();

  useEffect(() => {
    // 检查是否需要重定向
    const basePath = import.meta.env.VITE_BASE_PATH || '/';
    const currentPath = window.location.pathname;

    // 如果当前路径是根路径，且配置了非根的基础路径，则重定向
    if (currentPath === '/' && basePath !== '/') {
      window.location.replace(basePath);
      return;
    }
  }, []);

  return (
    <RouterProvider router={router} future={{ v7_startTransition: true }} />
  );
};

export default App;
